import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalDialog } from 'shared/components/modals/ModalDialog';
import {
    selectEditStep,
    selectIsOpenModal,
} from 'modules/subassignmentManagement/components/EditSubAssignment/store/selectors';
import {
    setOpenBulkEditSubassignmentModal,
} from 'modules/subassignmentManagement/components/EditSubAssignment/store/actions';
import { BulkEditSubassignmentSteps } from 'modules/subassignmentManagement/components/EditSubAssignment/store/model';
import { BulkEditSubAssignmentFormV2 } from 'modules/subassignmentManagement/components/EditSubAssignment/EditSubAssignmentForm/BulkEditSubAssignmentFormV2';
import { useEditBulkSubassignmentModalTitle } from 'modules/subassignmentManagement/components/EditSubAssignment/hooks';
import { DeletePreInitializeReport } from 'modules/subassignmentManagement/components/PreAndPostInitializeReports/DeletePreInitializeReport';
import { DeletePostInitializeReport } from 'modules/subassignmentManagement/components/PreAndPostInitializeReports/DeletePostInitializeReport';
import { BulkEditPostInitializeV2Report } from 'modules/subassignmentManagement/components/PreAndPostInitializeReports/BulkReportV2/BulkEditPostInitializeV2Report';
import { BulkEditPreInitializeV2Report } from 'modules/subassignmentManagement/components/PreAndPostInitializeReports/BulkReportV2/BulkEditPreInitializeV2Report';

export const BulkEditSubAssignmentModal = () => {
    const isOpened = useSelector(selectIsOpenModal);
    const step = useSelector(selectEditStep);
    const dispatch = useDispatch();

    const onClose = useCallback(() => {
        dispatch(setOpenBulkEditSubassignmentModal(false));
    }, [dispatch]);

    const { title, setAdditionalSteps } = useEditBulkSubassignmentModalTitle(isOpened);

    return (
        <ModalDialog
            title={title}
            isOpened={isOpened}
            onClose={onClose}
            colored
            modalProps={{
                showCloseIcon: true,
            }}
        >
            <>
                {step === BulkEditSubassignmentSteps.Form && (
                    <BulkEditSubAssignmentFormV2 setAdditionalSteps={setAdditionalSteps} />
                )}
                {step === BulkEditSubassignmentSteps.EditVerify && (
                    <BulkEditPreInitializeV2Report />
                )}
                {step === BulkEditSubassignmentSteps.DeleteVerify && (
                    <DeletePreInitializeReport />
                )}
                {step === BulkEditSubassignmentSteps.EditPostReport && (
                    <BulkEditPostInitializeV2Report onClose={onClose} />
                )}
                {step === BulkEditSubassignmentSteps.DeletePostReport && (
                    <DeletePostInitializeReport mainButtonHandler={onClose} />
                )}
            </>
        </ModalDialog>
    );
};
